import { t } from '@avalara/bat-apps-shared/i18n';
import type { PartnerSignupInfo } from '@avalara/types/reducer-states';
import { setPartnerBannerLogo } from './helpers/banner';
import { BannerMainImage, BannerTertiaryText, Banner as StyledBanner } from './styled/skylab/page';

type Props = {
  additionalClass?: string;
  backgroundImage?: string;
  image?: string;
  partnerLogo?: {
    length: number;
    name: string;
    img: string;
    bodyImg: string;
  } | null;
  partnerSignup?: PartnerSignupInfo;
  primaryText: string;
  secondaryText?: string | null;
  tertiaryText?: string;
  isMrsTrustfile?: boolean;
};

const Banner = ({
  additionalClass,
  backgroundImage,
  image,
  partnerLogo,
  primaryText,
  secondaryText,
  tertiaryText,
  partnerSignup,
  isMrsTrustfile = false,
}: Props) => (
  <StyledBanner className={additionalClass || ''} backgroundImage={backgroundImage || ''}>
    <div>
      <div className={'banner-content'} data-ref='buy.banner-content'>
        <h1 data-ref='buy.banner.header' id={'banner-title'}>
          {primaryText}
          {partnerLogo && setPartnerBannerLogo(partnerLogo)}
        </h1>
        {(partnerSignup || secondaryText) && (
          <h2 data-ref='buy.banner.secondary-header'>
            {partnerSignup && `Avalara AvaTax for ${partnerSignup.name}`}
            {!partnerSignup && secondaryText != null && secondaryText}
          </h2>
        )}
        {tertiaryText != null && tertiaryText && (
          <BannerTertiaryText data-ref='buy.banner.tertiary-content' hasBackgroundImage={backgroundImage != null}>
            {tertiaryText}
          </BannerTertiaryText>
        )}
      </div>
      {image != null && (
        <BannerMainImage
          src={image}
          alt={t('client.accessibility.banner-image')}
          isBundle={additionalClass === 'isBundle'}
          isMrsTrustfile={isMrsTrustfile}
        />
      )}
    </div>
  </StyledBanner>
);

export default Banner;
